/**
 * Small helpers to read Jkit dashboard options from the page.
 * Prefer `window.JkitDashboardOption` when present, otherwise fall back to `window.jkit`.
 */
export function getFreemiusPricing() {
    return (
        (typeof window !== 'undefined' && window['JkitDashboardOption'] && window['JkitDashboardOption'].freemius && window['JkitDashboardOption'].freemius.pricing)
        || (typeof window !== 'undefined' && window.jkit && window.jkit.options && window.jkit.options.freemius && window.jkit.options.freemius.pricing)
        || null
    );
}

export function getPricingPlan() {
    return (
        (typeof window !== 'undefined' && window['JkitDashboardOption'] && window['JkitDashboardOption'].pricingPlan)
        || (typeof window !== 'undefined' && window.jkit && window.jkit.pricingPlan)
        || null
    );
}

export function getImgDir() {
    return (
        (typeof window !== 'undefined' && window['JkitDashboardOption'] && window['JkitDashboardOption'].imgDir)
        || (typeof window !== 'undefined' && window.jkit && window.jkit.imgDir)
        || ''
    );
}

/**
 * Call `cb(config)` when pricing config is available.
 * Returns `true` if callback was invoked, otherwise `false`.
 */
export function withPricingConfig(cb) {
    const cfg = getFreemiusPricing();
    if (cfg) {
        try { cb(cfg); } catch (e) { /* swallow callback errors */ }
        return true;
    }
    return false;
}


// --- UTM tracker helpers (migrated here so consumers import a single helper file)

function generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
}

export function trackBeforeCheckout() {
    const trackerId = generateUUID();

    const urlParams = new URLSearchParams(window.location.search);
    const utm = {
        utm_source: urlParams.get('utm_source') || '',
        utm_medium: urlParams.get('utm_medium') || '',
        utm_campaign: urlParams.get('utm_campaign') || '',
    };

    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');
    const freemiusConfig = getFreemiusPricing();

    const proxyEndpoint = '/wp-json/jkit/v1/utm-proxy/';
    const nonce = (typeof window !== 'undefined' && (window.jkit?.wpRestNonce || window['JkitDashboardOption']?.wpRestNonce)) || '';

    fetch(proxyEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': nonce },
        body: JSON.stringify({
            tracker_id: trackerId,
            utm_source: utm.utm_source,
            utm_medium: utm.utm_medium,
            utm_campaign: utm.utm_campaign,
            utm_client_site: freemiusConfig?.client_site || window.location.hostname,
            utm_client_theme: freemiusConfig?.client_theme || '',
            _fbp: fbp,
            _fbc: fbc,
        }),
    }).catch(() => { /* ignore errors */ });

    return trackerId;
}
